module.exports = __webpack_public_path__ + "img/paymentBadgeCloud.73cca33.png";